import _ from 'lodash';
import initialState from './initialState.js';
import constants from '../helpers/constants.js';

export default function wishListReducer(state = initialState.wishList, action) {
    switch (action.type) {
        case constants.USER_WISHLIST_ID_NAME:
            return Object.assign({}, state, {
                wishListId: action.data.wishListId,
                wishListName: action.data.wishListName,
            });
        case constants.USER_WISHLIST_ENTRIES:
            return Object.assign({}, state, {
                entries: action.data.entries,
                errors: action.data.errors,
                hasUnavailableProducts: action.data.hasUnavailableProducts,
                isDefault: action.data.isDefault,
                productCount: action.data.productCount,
            });
        case constants.USER_WISHLIST_COUNT:
            return Object.assign({}, state, { productCount: action.data.productCount });

        default:
            return state;
    }
}
